import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Provider, Type } from '@angular/core';
import { BaseStoreFacade } from '@city/data-access';
import { BaseStoreInterceptor, CustomBaseSiteNormalizer } from '@city/feature';
import {
  BASE_SITE_CONTEXT_ID,
  BaseSiteNormalizer,
  BaseSiteService,
  CURRENCY_CONTEXT_ID,
  ContextServiceMap,
  CurrencyService,
  LANGUAGE_CONTEXT_ID,
  LanguageService,
  SiteContext,
} from '@spartacus/core';

export function serviceMapFactory(): { [context: string]: Type<SiteContext<any>> } {
  return {
    [LANGUAGE_CONTEXT_ID]: LanguageService,
    [CURRENCY_CONTEXT_ID]: CurrencyService,
    [BASE_SITE_CONTEXT_ID]: BaseSiteService,
    baseStore: BaseStoreFacade,
  };
}

export const contextServiceMapProvider: Provider = {
  provide: ContextServiceMap,
  useFactory: serviceMapFactory,
};

@NgModule({
  providers: [
    contextServiceMapProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: BaseStoreInterceptor,
      multi: true,
    },
    {
      provide: BaseSiteNormalizer,
      useClass: CustomBaseSiteNormalizer,
    },
  ],
})
export class BaseStoreModule {}
